<template>
  <div class="waveform-container">
    <canvas ref="canvas" class="waveform"></canvas>
  </div>
</template>

<script setup>
import { ref, watch, onUnmounted, nextTick } from "vue";
// eslint-disable-next-line 
const props = defineProps({
  active: Boolean,
  stream: Object,
})

const canvas = ref(null)

let audioContext = null
let analyser = null
let microphone = null
let animationId = null

const start = async () => {

  if (!props.stream) return
  if (audioContext) return

  console.log("Starting audio visualization with stream:", props.stream) // CHANGED: now this should print

  audioContext = new (window.AudioContext || window.webkitAudioContext)()

  if (audioContext.state === "suspended") {
    await audioContext.resume() // CHANGED: safer in browsers
  }

  analyser = audioContext.createAnalyser()
  analyser.fftSize = 2048
  analyser.smoothingTimeConstant = 0.85

  microphone = audioContext.createMediaStreamSource(props.stream)
  microphone.connect(analyser)

  draw()
}

const stop = () => {
  if (animationId) { // CHANGED: guard
    cancelAnimationFrame(animationId)
    animationId = null
  }

  if (microphone) { // CHANGED: disconnect source node, do not stop parent stream
    microphone.disconnect()
    microphone = null
  }

  if (audioContext) {
    audioContext.close()
    audioContext = null
  }

  analyser = null
}

const draw = () => {
  const canvasEl = canvas.value
  if (!canvasEl || !analyser) return

  const ctx = canvasEl.getContext("2d")

  const render = () => {
    animationId = requestAnimationFrame(render)

    const width = canvasEl.width = canvasEl.offsetWidth
    const height = canvasEl.height = canvasEl.offsetHeight

    const bufferLength = analyser.fftSize
    const dataArray = new Uint8Array(bufferLength)

    analyser.getByteTimeDomainData(dataArray)

    ctx.clearRect(0, 0, width, height)

    ctx.lineWidth = 2
    ctx.strokeStyle = "#518DB1"
    ctx.beginPath()

    const sliceWidth = width / bufferLength
    let x = 0

    for (let i = 0; i < bufferLength; i++) {
      const v = (dataArray[i] - 128) / 128
      const amplified = v * 2.8
      const y = height / 2 + amplified * (height / 2.2)

      if (i === 0)
        ctx.moveTo(x, y)
      else
        ctx.lineTo(x, y)

      x += sliceWidth
    }

    ctx.stroke()

    ctx.beginPath()
    ctx.lineWidth = 1
    ctx.strokeStyle = "rgba(81, 141, 177, 0.25)"
    ctx.moveTo(0, height / 2)
    ctx.lineTo(width, height / 2)
    ctx.stroke()
  }

  render()
}


watch(
  () => props.active,
  async (val) => {
    if (!val) {
      stop()
      return
    }

    await nextTick()
    await start()
  },
  { immediate: true } // CHANGED: run on mount too
)

watch(
  () => props.stream,
  async (newStream) => {
    console.log("stream changed:", newStream)

    if (!props.active) return

    stop()
    await nextTick()
    await start()
  },
)
onUnmounted(stop)
</script>

<style scoped>
.waveform-container {
  width: 100%;
  height: 80px;
  background: #f4f7fb;
  border-radius: 10px;
  padding: 5px;
}

.waveform {
  width: 100%;
  height: 100%;
}
</style>